angular.module("dx.webapp.share").constant("DX_SHARE", Object.freeze({
	EXAM_TEMPLATES: 0,
	RUBRIC: 1,
	GRADING: 2,
}));
